import { WORKER_STATICS_FOLDER } from '@wix/cli-app-definitions';
import { mergeConfig } from 'vite';
import type { InlineConfig } from 'vite';
import type { ProjectModel } from '../../../model.js';
import type { ViteBuildConfigOptions } from '../../vite-config-options.js';
import {
  virtualBlocksWidgetScriptAssets,
  virtualBlocksWidgetPanelScriptAssets,
} from '../../../dev-center/components/site/config.js';
import { moduleBundleBuildBlocks } from '../../plugins/module-bundle/plugin.js';
import { getBaseViteConfig } from './base.js';

export function getViteConfig(
  model: ProjectModel,
  options: ViteBuildConfigOptions
): InlineConfig {
  const virtualBlocksScriptEntries = [
    ...virtualBlocksWidgetScriptAssets(model),
    ...virtualBlocksWidgetPanelScriptAssets(model),
  ].map(([assetId, component]) => [`script-asset-${component.id}`, assetId]);

  const baseConfig = getBaseViteConfig({
    ...options,
    model,
    outputDir: WORKER_STATICS_FOLDER,
  });

  const config = {
    ssr: {
      target: 'webworker',
      noExternal: true,
    },
    build: {
      ssr: true,
      rollupOptions: {
        input: {
          ...Object.fromEntries(virtualBlocksScriptEntries),
        },
        output: {
          // Need it to preserve shapes of our exports from virtual module bundles
          minifyInternalExports: false,
        },
      },
    },
    plugins: [moduleBundleBuildBlocks({ initialModel: model })],
  } satisfies InlineConfig;

  return mergeConfig(config, baseConfig);
}
